module.exports = __webpack_public_path__ + "98517200f4db9aa89e9262f06712178d.jpg";